import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare } from '@fortawesome/pro-light-svg-icons'

import {
  Button,
  Columns,
  LoadingModule,
  Tools,
} from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'
import useOrderItems from '@hooks/useOrderItems'

import CampaignTeam from '@components/CampaignTeam'
import LinkToEntityModule from '@components/LinkToEntityModule'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import { providerRoles } from '@functions/role'

import PageLayout from '../../../../components/PageLayout'
import OrderItem from '../OrderItem'

const PageContent = (props: { campaignId: number}) => {
  const { campaignId } = props

  const campaignPayload = useCampaign({ id: campaignId })

  const {
    agency,
    callbacks: {
      shareProjectModal,
    },
    campaign,
    loading: campaignLoading,
  } = campaignPayload

  const orderItemsPayload = useOrderItems({
    filters: { campaign_id: campaignId },
    requestOptions: {
      include_attachment_file: true,
      include_order_item_attachments: true,
      include_order_item_booking: true,
      include_order_item_campaign_id: true,
      include_order_item_due_date: true,
    },
    performHttpRequests: !!campaignId,
  })

  const {
    filteredOrderItems,
    hasFilteredOrderItems,
    loading: orderItemsLoading,
  } = orderItemsPayload

  const {
    title: agencyTitle,
    business_name: agencyBusinessName,
    short_name: agencyShortName,
  } = agency || {}

  const { provider } = useCurrentUser()

  return (
    <PageLayout entityPayload={campaignPayload} activeTabBarItemKey="media">
      <Columns.Main>
        <LoadingModule loading={campaignLoading || orderItemsLoading} times={3} />

        <ScopedConditionalContent permittedRoleTitles={providerRoles}>
          {!orderItemsLoading && hasFilteredOrderItems && (
            filteredOrderItems.map(orderItem => (
              <OrderItem
                campaignTitle={campaign?.title}
                key={orderItem.id}
                orderItem={orderItem}
              />
            ))
          )}
        </ScopedConditionalContent>
      </Columns.Main>

      <Columns.Sidebar>
        <Tools>
          <ScopedConditionalContent permittedRoleTitles={providerRoles}>
            <Button
              buttonStyle="secondaryUtility"
              icon={<FontAwesomeIcon icon={faShare} />}
              // @ts-expect-error TS2345
              onClick={() => shareProjectModal(provider)}
              size="medium"
            >
              Share Project
            </Button>
          </ScopedConditionalContent>
        </Tools>

        <LinkToEntityModule
          entityTitle={agencyTitle || ''}
          loading={campaignLoading}
          moduleTitle="Agency"
          secondaryText={agencyShortName || agencyBusinessName}
        />

        {!campaignLoading && (<CampaignTeam campaign={campaign} />)}
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
